// extracted by mini-css-extract-plugin
export var chip = "_55-9";
export var chipLabel = "_55-a";
export var close = "_55-7";
export var closeIcon = "_55-8";
export var error = "_55-6";
export var infoTooltip = "_55-2";
export var innerContainer = "_55-1";
export var input = "_55-b";
export var medium = "_55-5";
export var outerContainer = "_55-0";
export var small = "_55-4";
export var xSmall = "_55-3";